import classNames from 'classnames';

import { MediaAspectRatioWarning } from '@/components/MediaAspectRatioWarning';
import { Image } from '@/ui/Image/Image';

import styles from './Media.module.scss';

type CommonProps = {
    alt: string;
    className?: string;
    blockType?: string;
};

type ImageProps = {
    type: 'image';
    src: Image.Props['src'];
    aspectRatio?: string;
    preload?: boolean;
    sizes?: Image.Props['sizes'];
};

type VideoProps = {
    type: 'video';
    src: string;
    aspectRatio?: string;
    preload?: never;
    sizes?: never;
};

type Props = CommonProps & (ImageProps | VideoProps);

export function Media({
    alt,
    aspectRatio,
    className,
    blockType = 'Section.Media',
    type,
    src,
    preload,
    sizes,
}: Props) {
    return (
        <div className={classNames(styles.wrapper, className)}>
            {!aspectRatio && (
                <MediaAspectRatioWarning
                    blockType={blockType}
                    hasMedia
                    mediaAspectRatio={aspectRatio}
                />
            )}
            {type === 'image' && (
                <div className={styles.imageContainer} style={{ aspectRatio }}>
                    <Image
                        src={src}
                        className={styles.image}
                        alt={alt}
                        sizes={sizes}
                        priority={preload}
                    />
                </div>
            )}

            {type === 'video' && (
                <div
                    className={styles.videoContainer}
                    data-component="feature-animation"
                    data-component-tour-video-title={alt}
                    style={{ aspectRatio }}
                >
                    {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
                    <video
                        autoPlay
                        className={styles.video}
                        src={`${src}#t=0.1`}
                        width="100%"
                        playsInline
                        loop
                        muted
                    />
                </div>
            )}
        </div>
    );
}
